<div class="container" style="padding-top:100px;">
  <img width="50%" height="50%" src="../../../assets//images/unauthorized.svg">

</div>
<div class="col-12">
  <div class="row" style="justify-content: center">
    <button type="button" class="btn btn-custom_primary ml-2 mr-2 " id="inv_setup_save" data-backdrop="static"
      data-keyboard="false" (click)="cancel()">Go Back </button>
  </div>
</div>